import React from 'react';

function JftDash() {
  return <div>JFT Dashboard</div>;
}

export default JftDash;
